import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { SetupService } from '@questelservices/common';
import { getModule } from 'vuex-module-decorators';
import CommonModule from '@questelservices/common';
import './filters/filters';


Vue.config.productionTip = false;

// initialize application
(async () => {
  await new SetupService(store).initializeApp();

  let rootElement = new Vue({
    router,
    store,
    render: h => h(App)
  });

  rootElement.$mount('#app');

  const commonState = getModule(CommonModule, store);
  if (commonState.isAuthenticated) {
    rootElement.$root.$emit('login-success');
  }
})();
